import script from "./CookieConcentBanner.vue?vue&type=script&lang=js"
export * from "./CookieConcentBanner.vue?vue&type=script&lang=js"

import "./CookieConcentBanner.vue?vue&type=style&index=0&id=651adf70&lang=css"

const __exports__ = script;

export default __exports__